import React, { useEffect, useState } from "react"; 
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom"; 
import { Link } from "react-router-dom";
import TimeCompo from "../components/TimeCompo";

export default function UserNavbar() {
  const [orgs, setOrgs] = useState([]);
  const [selectedOrgName, setSelectedOrgName] = useState("Organization");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  // useEffect(() => {
  //   const assignee_id = localStorage.getItem("assignee_id");
  //   if (!assignee_id) {
  //     navigate("/");  
  //   }
  // }, [navigate]);

  const handleLogout = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You will be logged out!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, logout",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        localStorage.removeItem("assignee_id");
        Swal.fire({
          icon: "success",
          title: "Logged out!",
          text: "You have been logged out successfully.",
          timer: 1500,
          showConfirmButton: false,
        });
        navigate("/user-login");
      }
    });
  };

  useEffect(() => {
    // Check if switching org
    const isSwitching = localStorage.getItem("org_switching");

    if (isSwitching === "true") {
      setLoading(true);
      setTimeout(() => {
        localStorage.removeItem("org_switching");
        setLoading(false);
        window.location.reload(); // Continue the reload
      }, 1000);
      return;
    }

    const defaultId = localStorage.getItem("default");
    const defaultName = localStorage.getItem("organization_name");
    const otherOrgs = JSON.parse(localStorage.getItem("other_org")) || [];

    const allOrgs = [
      { id: defaultId, name: defaultName, isDefault: true },
      ...otherOrgs.map((org) => ({ ...org, isDefault: false })),
    ];

    setOrgs(allOrgs);
    setSelectedOrgName(defaultName || "Organization");
  }, []);

  

  if (loading) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "100vh" }}
      >
        <div className="text-center">
          <div className="spinner-border text-primary mb-3" role="status"></div>
          <div className="fw-bold">Loading data...</div>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="container-fluid py-2 border-bottom d-flex justify-content-between align-items-center bg-white shadow-sm">
        {/* Left: Org Name Dropdown */}
        <div className="d-flex align-items-center gap-3">
          <h4 className="fw-bold mb-0">BOSPLAN Dashboard</h4>
          <div className="dropdown">
             
           
          </div>
        </div>

        {/* Center: Time */}
        {/* <TimeCompo/> */}

        {/* Right: Settings and Messages */}
        <div className="d-flex gap-2">
          {/* <Setting /> */}
          {/* <ActivityLog/> */}

          {/* <Link to="/logs" target="_blank" className="btn new-project-btn d-flex align-items-center gap-1 px-3 py-2">
            <i className="bi bi-chat-dots"></i> Activity
          </Link> */}


          <Link to="/messages" className="btn new-project-btn d-flex align-items-center gap-1 px-3 py-2">
            <i className="bi bi-chat-dots"></i> Messages
          </Link>

          <button
            className="btn new-project-btn d-flex align-items-center gap-1 px-3 py-2"
            onClick={handleLogout}
          >
            <i className="bi bi-box-arrow-right"></i> Logout
          </button>
        </div>
      </div>
    </>
  );
}
